import React from 'react';
import LandingPage from '../views/LandingPage/LandingPage';

// eslint-disable-next-line react/display-name
export default () => <LandingPage />;
